import { StyleSheet, Image, View, useWindowDimensions, Pressable, Text } from 'react-native'
import React, { useState } from 'react'
import Ionicons from '@expo/vector-icons/Ionicons'
import _ from 'lodash'
import Menu from '../Menu'
import { menus } from '../../data'
import { colors } from '../../colors'
import { displayFont } from '../../fonts'

const Header = ({ selectedRoute, setSelectedRoute }) => {
  const window = useWindowDimensions()
  const narrow = window.width < 768
  const [open, setOpen] = useState(false)

  if (narrow) {
    return (
      <View style={[styles.glass, styles.mobileWrap, {backdropFilter: 'blur(18px)', WebkitBackdropFilter: 'blur(18px)', position: 'fixed', top: 'max(10px, env(safe-area-inset-top))', left: 12, right: 12, zIndex: 30}]}>
        <View style={styles.mobileBar}>
          <View style={styles.brand}>
            <Image
              accessibilityElementsHidden
              importantForAccessibility="no"
              resizeMode="contain"
              style={styles.logoNarrow}
              source={{ uri: 'https://ivyooo.com/assets/images/ivyooo.png' }}
            />
            <Text style={styles.wordmark}>iVYOOO</Text>
          </View>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel={open ? 'Close menu' : 'Open menu'}
            accessibilityState={{ expanded: open }}
            onPress={() => setOpen((value) => !value)}
            style={({ focused }) => [styles.menuButton, focused && styles.focused]}
          >
            <Text style={styles.menuButtonText}>{selectedRoute}</Text>
            <Ionicons accessibilityElementsHidden importantForAccessibility="no" name={open ? 'chevron-up' : 'chevron-down'} size={18} color={colors.white} />
          </Pressable>
        </View>
        {open && (
          <View style={styles.dropdown}>
            {_.map(menus, (item, index) => (
              <Pressable
                accessibilityRole="button"
                key={`${item?.text}-${index}`}
                accessibilityState={{ selected: selectedRoute === item?.text }}
                onPress={() => {
                  setSelectedRoute(item?.text)
                  setOpen(false)
                }}
                style={({ focused }) => [styles.dropdownItem, focused && styles.focused]}
              >
                <Text style={[styles.dropdownText, selectedRoute === item?.text && styles.dropdownTextActive]}>{item?.text}</Text>
              </Pressable>
            ))}
          </View>
        )}
      </View>
    )
  }

  return (
    <View style={[styles.container, narrow && styles.containerNarrow, styles.glass, {backdropFilter: 'blur(18px)', WebkitBackdropFilter: 'blur(18px)', position: 'absolute', top: 12, zIndex: 20}]}>
      <View style={styles.brand}>
        <Image
          accessibilityElementsHidden
          importantForAccessibility="no"
          resizeMode="contain"
          style={[styles.logo, narrow && styles.logoNarrow]}
          source={{ uri: 'https://ivyooo.com/assets/images/ivyooo.png' }}
        />
        <Text style={styles.wordmark}>iVYOOO</Text>
      </View>
      <View style={[styles.nav, narrow && styles.navNarrow]}>
        {_.map(menus, (item, index) => (
          <Menu
            bar
            compact={narrow}
            key={`${item?.text}-${index}`}
            selectedRoute={selectedRoute}
            setSelectedRoute={setSelectedRoute}
            text={item?.text}
          />
        ))}
      </View>
    </View>
  )
}

export default Header

const styles = StyleSheet.create({
  container: {
    minHeight: 72,
    marginHorizontal: 16,
    marginTop: 12,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 20,
    position: 'absolute',
    top: 12,
    left: 16,
    right: 16,
    borderRadius: 18,
  },
  glass: {
    backgroundColor: 'rgba(8, 8, 8, 0.62)',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.18)',
    borderRadius: 18,
    backdropFilter: 'blur(18px)',
    WebkitBackdropFilter: 'blur(18px)',
  },
  containerNarrow: {
    minHeight: 64,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  logo: {
    width: 52,
    height: 52,
  },
  logoNarrow: {
    width: 40,
    height: 40,
  },
  brand: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  wordmark: {
    color: colors.white,
    fontFamily: displayFont,
    fontSize: 18,
    fontWeight: '700',
    letterSpacing: 1.4,
    marginLeft: 8,
  },
  nav: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 28,
    marginLeft: 24,
  },
  navNarrow: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  mobileWrap: {
    zIndex: 20,
    position: 'absolute',
    top: 10,
    left: 12,
    right: 12,
    borderRadius: 18,
    overflow: 'hidden',
  },
  mobileBar: {
    minHeight: 64,
    paddingHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  focused: {
    outlineWidth: 2,
    outlineStyle: 'solid',
    outlineColor: '#FFFFFF',
    outlineOffset: 2,
  },
  menuButton: {
    minHeight: 44,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  menuButtonText: {
    color: colors.white,
    fontFamily: displayFont,
    fontSize: 14,
    fontWeight: '600',
    letterSpacing: 0.6,
    marginRight: 6,
  },
  dropdown: {
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.14)',
    paddingBottom: 8,
  },
  dropdownItem: {
    minHeight: 48,
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  dropdownText: {
    color: colors.white,
    fontFamily: displayFont,
    fontSize: 16,
    fontWeight: '600',
    letterSpacing: 0.8,
  },
  dropdownTextActive: {
    color: colors.red,
  },
})
